import { DateField } from '@shared/data/entity/fields/DateField';

/** A date field as one line of text: its date and time, "Oct 1, 2026, 5pm". */
export function getDateText(field: DateField): string {
  return field.toDisplayString();
}
